import { render, staticRenderFns } from "./adminuseinfo.vue?vue&type=template&id=6c71b52c&scoped=true"
import script from "./adminuseinfo.vue?vue&type=script&lang=js"
export * from "./adminuseinfo.vue?vue&type=script&lang=js"
import style0 from "./adminuseinfo.vue?vue&type=style&index=0&id=6c71b52c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c71b52c",
  null
  
)

export default component.exports